var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 9,
    viewBox: "0 0 59 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.625 7.57931C10.2917 2.91265 28.5672 -2.13214 51.3672 3.46786",
    stroke: "#A9CF3D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.875,
    cy: 6.5,
    r: 1.5,
    fill: "#A9CF3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurveIcon);
export default __webpack_public_path__ + "static/media/curve-icon.b82eeeb0fbfdadd1e2d8d2da2b25d09c.svg";
export { ForwardRef as ReactComponent };